const MuiToolbar = {
  styleOverrides: {
    root: {
      height: '11.8rem',
    },
  },
};

export default MuiToolbar;
